import mixpanel from "mixpanel-browser"
import { FLASHCARDS_EVENTS } from "."

interface StartFlashcardProps {
  startDate: string
  userPlan: string
  userName: string
  userEmail: string
}

export function startFlashcard(props: StartFlashcardProps) {
  return mixpanel.track(FLASHCARDS_EVENTS.START_FLASHCARD, {
    ...props,
  })
}
